import z from 'zod'
import {
  firestoreWriteTimestamp,
  nullSafeOptionalFirestoreTimestamp,
} from '../shared/schema'

export const schema = z.object({
  sectionId: z.string(),
  assignmentId: z.string(),
  prQuestion: z.string(),
  prDescription: z.string(),
  prOrder: z.number(),
  updatedAt: nullSafeOptionalFirestoreTimestamp(),
})

export const writeSchema = schema.extend({
  updatedAt: firestoreWriteTimestamp,
})

export const empty = Object.freeze(
  schema.parse({
    sectionId: '',
    assignmentId: '',
    prQuestion: '',
    prDescription: '',
    prOrder: 0,
    updatedAt: { seconds: 0, nanoseconds: 0 },
  })
)

export interface FirestorePeerReviewQuestion extends z.infer<typeof schema> {}
